// transformNode.js
import { Position } from 'reactflow';
import { BaseNode } from './BaseNode';

export const TransformNode = ({ id, data }) => {
    return (
        <BaseNode
            id={id}
            data={data}
            title="Transform"
            handles={[
                { type: 'target', position: Position.Left, id: `${id}-input` },
                { type: 'source', position: Position.Right, id: `${id}-output` }
            ]}
        >
            <div className="text-sm text-gray-500">
                <span>Transform input</span>
            </div>
        </BaseNode>
    );
};
